<template>
  <div ref="mapElement" style="height: 570px;width:100%; margin-left: 15px;margin-top: 5px;position: relative;"></div>
</template>

<script>
import L from 'leaflet';
import commonJS from '../../../subscriberconfig/mcsSubscriber/common';
import { EventBus } from '../../../../plugins/eventBus';
import iconPonit from '../../../subscriberMicro/util/img/marker-icon-red.png';
import othericonPonit from '../../../subscriberMicro/util/img/marker-icon.png';

export default {
  name: 'GpsMap',
  props: [
    'mapConfig'
  ],
  mixins: [commonJS],
  data() {
    return {
      map: null,
      bsDeviceId:'',
      bsEquipment : [],
      // mapConfig: {
      //   longitude: 121.433,
      //   latitude: 28.662,
      //   mapSize: 16,
      //   scrollFlag: false
      // },
      oldBSMarker:null,
      hasGPS:false,
      allBSMarker:[],
      curIcon : L.icon({
        iconUrl: iconPonit,
        iconSize: [25, 41],
        iconAnchor: [12.5, 35.5],
      }),
      otherIcon: L.icon({
        iconUrl: othericonPonit,
        iconSize: [25, 41],
        iconAnchor: [12.5, 35.5],
      }),
      // zoom:13,
    };
  },
  methods: {
    
    qryAllPoint(){
      this.allBSMarker.forEach((marker) =>{
        this.map.removeLayer(marker);
      })
      this.hasGPS = false;
      const typeCode = '10009,10001,10004';
      //地图中心点
      this.map.setView([this.mapConfig.latitude, this.mapConfig.longitude], this.mapConfig.zoom);
      this.$axios.get(`/lte/ems/topo/queryEquipmentByTypeCode?typeCode=${typeCode}`).then((response) => {
        if (response && response.status === 200  && response.data.errorCode === 'SUCCESS') {
          response.data.resultVal.forEach((bs =>{
            if(bs.latitude !=null && bs.longitude !=null){
              let location = [parseFloat(bs.latitude), parseFloat(bs.longitude)];
              
              if(bs.id == this.bsDeviceId ){
                this.oldBSMarker= L.marker(location, {
                  icon: this.curIcon,
                  draggable: false

                })
                this.map.addLayer(this.oldBSMarker);
                this.allBSMarker.push(this.oldBSMarker);
                this.map.setView(location, this.mapConfig.zoom);
                this.hasGPS = true;
              }else{
                let bsmarker = L.marker(location, {
                  icon: this.otherIcon,
                  draggable: false

                })
                this.map.addLayer(bsmarker);
                this.allBSMarker.push(bsmarker);
              }
            }
            
          }))
        }
      })
      
      
      
    },

    /**
     * 初始化地图方法
     */
    initMap() {
      
      const webUrl = '/UniNM/map/{z}/{x}/{y}.png';
      const mapLayer = L.tileLayer(webUrl);
      this.map = L.map(this.$refs['mapElement'], {
        layers: [mapLayer],
      }).setView([this.mapConfig.latitude, this.mapConfig.longitude],this.mapConfig.zoom);
      // }).setView([ 45.80155039475129,126.53095722198488],this.mapConfig.zoom);
      
      //添加点击监听
      this.map.on('click', this.onMapClick);
      
    },
    

    onMapClick(e) {
      
      if(null != this.oldBSMarker){
        this.map.removeLayer(this.oldBSMarker);
      }
      
      let newBSMarker = L.marker(e.latlng, {
        icon: this.curIcon,
        draggable: false
      });
      
      this.map.addLayer(newBSMarker);
      this.allBSMarker.push(newBSMarker);
      this.map.setView(e.latlng,this.zoom);
      
      this.bsEquipment[0].latitude = e.latlng.lat;
      this.bsEquipment[0].longitude = e.latlng.lng;
      
      this.$axios.post('/lte/ems/topo/ne/changeEquipmentPosition', this.bsEquipment).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
      
        }else{
          EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
        }
        this.allBSMarker.forEach((marker) =>{
          this.map.removeLayer(marker)
        })
        this.oldBSMarker = null;
        this.$parent. $parent.$parent.$refs.changeGPSDialog.clear();
        this.$parent. $parent.$parent.$refs.changeGPSDialog.close();
      })
    
    },
    removeCurGPS(){
      
      if(!this.hasGPS){
        EventBus.$emit('toast', {type: 'error', content: this.$t('DeployManagement.hasnotGPS')});
        return ;
      }
      this.bsEquipment[0].latitude = null;
      this.bsEquipment[0].longitude = null;
      
      this.$axios.post('/lte/ems/topo/ne/changeEquipmentPosition', this.bsEquipment).then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Topo.delSuccess')});
          this.map.removeLayer(this.oldBSMarker);
        }else{
          EventBus.$emit('toast', {type: 'error', content: this.$t('Topo.deleteFailed')});
        }
        
      })
       

    },
    cancel(){
      this.allBSMarker.forEach((marker) =>{
        this.map.removeLayer(marker)
      })
      this.oldBSMarker = null;
      this.$parent. $parent.$parent.$refs.changeGPSDialog.clear();
      this.$parent. $parent.$parent.$refs.changeGPSDialog.close();
    }
    
  },
  mounted() {
    this.initMap();
  },
  
}
</script>

<style scoped>
@import '~leaflet/dist/leaflet.css';

#mapElement {
width:100%;
height:100vh;
 
}
</style>
